<script>
export default {
  name: "HelperItem",
  props: [
    'quadrant'
  ],
  computed: {
    slug()  { return this.quadrant && this.quadrant.slug },
    title() { return this.quadrant && this.quadrant.Title },
    arrow() { return this.getArrow(this.quadrant.Position) },
    desiresInlay() { return this.$store.state.access.desiresInlay }

  },
  methods: {
    getArrow: position =>
      position == 'top'    ? '↑' :
      position == 'right'  ? '→' :
      position == 'bottom' ? '↓' :
      position == 'left'   ? '←' : '○',
    goToItem() {
      this.$router.push({
        path: this.slug,
        query: {
          inlay: this.slug == 'map' ? this.desiresInlay ? undefined : 'physical' : undefined
        }
      })
    },
  }
}
</script>

<template>
  <div
    class="helperItem"
    role="menuitem"
    tabindex="0"
    :aria-label="title"
    @click="goToItem()"
    @keydown.space="goToItem()"
    @keydown.enter="goToItem()"
    v-if="slug !== '404'"
  >
    <a
      @mousedown.stop
      @mouseup.stop
    >
      <!-- <span class="arrow"> {{ arrow }} </span> -->
      <span class="title"> {{ title }} </span>
    </a>
  </div>
</template>

<style scoped>

.helperItem {
  font-size: inherit;
  animation: enter var(--slow) ease-out;
  text-align: center;
  padding: 0.1em;
  transition: all var(--slow) ease;
}
@keyframes enter {
  from {
    font-size: 0;
  }
  to {
    font-size: inherit;
  }
}


.helperItem .arrow {
  margin: 0 0.5em;
}
.helperItem .title {
  padding: 0.2em 0.5em;
}

.helperItem a {
  font-size: inherit;
}

.helperItem:focus a {
  background: var(--back);
  color: var(--light2);
}

.isMobile .helperItem {
  opacity: 0;
  pointer-events: none;
}

.isMobile nav:hover .helperItem {
  opacity: 1;
  pointer-events: all;
}

@media screen and (max-width : 1100px)  and (min-width : 750px) {
/* @media screen and (max-width : 1100px)  { */
  .helperItem {
    opacity: 0;
    pointer-events: none;
  }

  nav:hover .helperItem {
    opacity: 1;
    pointer-events: all;
  }

}

</style>
